import { render, staticRenderFns } from "./SunFlower.vue?vue&type=template&id=521d528f&"
import script from "./SunFlower.vue?vue&type=script&lang=ts&"
export * from "./SunFlower.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports